<div class="applications-part">
	<readonly-access [readonly]="dialogDataService.isReadonly()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="applications()"></grid-content>
</div>